import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { RateLimitService } from '../../services/rate-limit.service';

interface IViewProfileModalContext {
  data: any;
  title?: string;
}

@Component({
  selector: 'app-view-geofence-profile',
  templateUrl: './view-geofence-profile.component.html',
  styleUrls: ['./view-geofence-profile.component.scss'],
})
export class ViewGeofenceProfileComponent implements OnInit {
  success: any;
  geofenceProfileLoading = false;
  error: any;
  user: any;
  geofenceProfile: any;
  constructor(
    public modal: SuiModal<IViewProfileModalContext, void, void>,
    private rateLimitSvc: RateLimitService
  ) {
    this.geofenceProfileLoading = true;

    // Get the geofenceProfileIds as an array
    const geofenceProfileIds =
      this.modal.context.data.metadata.geofenceProfileId.split(',');

    this.rateLimitSvc
      .getProfiles(this.modal.context.data.user.appUserId)
      .subscribe(
        (res: any) => {
          // Filter and collect all matching profiles
          this.geofenceProfile = res.geofenceProfiles.filter((profile) =>
            geofenceProfileIds.includes(profile.geoFenceProfileId)
          );

          this.geofenceProfileLoading = false;
        },
        (error) => {
          this.error =
            error.error?.errorMessage ||
            error.error?.error ||
            error.error ||
            error.message ||
            error;
          this.geofenceProfileLoading = false;
        }
      );
  }

  ngOnInit(): void {}
}
export class ViewGeofenceProfileModal extends ComponentModalConfig<
  IViewProfileModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(ViewGeofenceProfileComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
